import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-getnet-retorno',
  template: `
    <div class="getnet-retorno">
      <h5 *ngIf="sucesso">
        <i class="k-icon k-i-check-circle fa-2x text-success mr-2"></i>
        Pagamento recebido pela Getnet.
      </h5>

      <h5 *ngIf="!sucesso">
        <i class="k-icon k-i-times-circle fa-2x text-danger mr-2"></i>
        Não foi possível concluir o pagamento pela Getnet.
      </h5>

      <p class="mt-3 mb-0">Esta janela será fechada automaticamente.</p>
    </div>
  `,
  styles: [`
    .getnet-retorno{
      align-items: center;
      background: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: 100vh;
      padding: 24px;
      text-align: center;
    }
  `]
})
export class GetnetRetornoComponent implements OnInit {
  sucesso: boolean;

  constructor(private activatedRoute: ActivatedRoute) {
    this.sucesso = this.activatedRoute.snapshot.params.status === 'success';
  }

  ngOnInit(): void {
    setTimeout(() => {
      window.parent.postMessage({
        origem: 'promokit-getnet',
        acao: 'fechar-lightbox',
        status: this.sucesso ? 'success' : 'error'
      }, '*');
    }, 5000);
  }

  deveExibirTopo(){
    return false;
  }

  deveExibirMenu(){
    return false;
  }

  deveTerBordas(){
    return false;
  }

  deveExibirBannerTema(){
    return false;
  }
}
